@defer { @if (isLoading()) {
<section class="py-40 flex items-center justify-center w-full h-full">
  <span class="loading loading-spinner text-primary-500 loading-md"></span>
</section>
} @else { @if (!query()) {
<section class="flex flex-col items-center justify-center w-full h-full py-40 gap-3">
  <app-icon name="tabler:mood-sad-filled" size="lg" class="text-gray-400 size-10" />
  <p class="text-gray-400">
    <ng-content />
  </p>
</section>
} @else {
<section class="flex flex-col items-center justify-center w-full h-full py-40 gap-3">
  <app-icon name="tabler:mood-sad-filled" size="lg" class="text-gray-400 size-10" />
  <div class="text-center flex flex-col gap-2 text-zinc-600">
    <p class="text-sm">
      "
      <span class="text-primary-500">
        {{ query() || '검색어' }}
      </span>
      " 에 대한 검색 결과가 없습니다.
    </p>
    <p class="text-xs">검색 결과를 확인해주세요.</p>
  </div>
</section>
} } } @loading {
<section class="py-40 flex items-center justify-center w-full h-full">
  <span class="loading loading-spinner text-primary-500 loading-md"></span>
</section>
} @placeholder {
<section class="py-40 flex items-center justify-center w-full h-full">
  <span class="loading loading-spinner text-primary-500 loading-md"></span>
</section>
}
